import * as React from "react";
import { useCallback } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { Icon, Link } from "components/common";
import QueryHelper from "components/common/QueryHelper";
import Routes from "routing/Routes";
import { fetchSavedSearches, queryKey } from "views/hooks/useSavedSearches";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
const DEFAULT_LAYOUT = {
  entityTableId: "saved-searches-for-investigations",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "description", "summary"],
  defaultColumnOrder: ["title", "summary", "description", "owner", "created_at", "favorite"]
};
const StyledIcon = styled(Icon)(
  ({ theme, $isFavorite }) => css`
    color: ${$isFavorite ? theme.colors.variant.info : void 0};
  `
);
const useColumnRenderers = () => ({
  attributes: {
    title: {
      renderCell: (title, search) => /* @__PURE__ */ React.createElement(Link, { to: Routes.VIEWS.VIEWID(search.id) }, title)
    },
    favorite: {
      renderCell: (isFavorite) => /* @__PURE__ */ React.createElement(StyledIcon, { $isFavorite: isFavorite, name: "star", type: isFavorite ? "solid" : "regular" })
    }
  }
});
const SavedSearchesOverview = ({ onAddSearch }) => {
  const renderSavedSearchActions = useCallback(
    (search) => /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", onClick: () => onAddSearch(search.id) }, "Add Search"),
    [onAddSearch]
  );
  const customColumnRenderers = useColumnRenderers();
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      columnRenderers: customColumnRenderers,
      entityActions: renderSavedSearchActions,
      entityAttributesAreCamelCase: true,
      fetchEntities: fetchSavedSearches,
      humanName: "Saved Searches",
      keyFn: queryKey,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "search", commonFields: ["id", "title"] }),
      tableLayout: DEFAULT_LAYOUT,
      withoutURLParams: true
    }
  );
};
export default SavedSearchesOverview;
